<template>
    <v-container>
        <div class="my-3 d-flex justify-left">
            <h1 class="uiTitle header">
                Berechnungsvorlage speichern
            </h1>
        </div>
        <p class="validationError" v-if="error">
            <v-icon style="color:#c50517">mdi-alert</v-icon><strong v-html="errorText"></strong>
        </p>
        <div class="d-flex justify-center">
            <v-text-field v-model="dateiname" maxlength="60" counter="60" :rules="rulesD" label="Dateiname"></v-text-field>
        </div>
        <div class="d-flex justify-center">
            <v-text-field v-model="kommentar" maxlength="100" counter="100" :rules="rulesK" label="Kommentar"></v-text-field>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
            <v-btn v-on:click="cancel" outlined large color="indigo" aria-labelled-by="Abbrechen"><span class="black--text subtitle-1">Abbrechen</span></v-btn>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue, Prop} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';

    @Component
    export default class Save extends Vue {

        @Prop({ default: false }) edit
        @Prop({ default: "" }) dateinameAlt
        @Prop({ default: "" }) kommentarAlt

        data() {
            return {
                error: false,
                errorText: this.$t('save.validationError'),
                dateiname: this.dateinameAlt,
                rulesD: [v => v.length <= 60 || 'Maximal 60 Zeichen erlaubt'],
                kommentar: this.kommentarAlt,
                rulesK: [v => v.length <= 100 || 'Maximal 100 Zeichen erlaubt'],
                editMode: this.edit,
                existingChosen: "",
                updateLink: "",
                anlagedatum: "",
                anlagenutzer: "",
                validationFailed: this.$t('save.validationError'),
                alreadyExists: "Name existiert bereits, bitte bestätigen Sie das Überschreiben der Berechnungen durch den Speichern-Button!"
            };
        }

        checkForm() {
            this.error = false;
            let matcher = /[^\w\-.\säÄöÖüÜß]/;
            //"."," ",".","_" allowed
            if(this.dateiname.match(matcher) || this.dateiname === "" || !this.dateiname.match(/\S/)) {
                this.error = true;
            }
            if(document.getElementsByClassName('error--text').length > 0){
                return false
            }
            return !this.error;
        }

        save() {
            if(this.checkForm()){
                if(this.editMode){
                    if(this.dateiname != this.dateinameAlt){
                        this.vorlageExists(this.dateiname).then(exists => {
                            if(exists){
                                console.log("already exists")
                                this.errorText = this.$t('save.editError')
                                this.error = true
                            } else {
                                this.doEdit()
                            }
                        });
                    }else{
                        this.doEdit()
                    }
                }else if(this.errorText === this.alreadyExists){
                    if(this.dateiname === this.existingChosen){
                        EventBus.$emit('update', { dateiname: this.dateiname, kommentar: this.kommentar, updateLink: this.updateLink,
                                                    anlagedatum: this.anlagedatum, anlagenutzer: this.anlagenutzer })
                        this.$router.go(-1)
                        this.errorText = this.validationFailed
                    } else {
                        this.errorText = this.validationFailed
                        this.save()
                    }
                } else {
                    this.vorlageExists(this.dateiname).then(exists => {
                        if(exists){
                            console.log("already exists")
                            this.existingChosen = this.dateiname
                            this.errorText = this.alreadyExists
                            this.error = true
                        }else{
                            EventBus.$emit('save', { dateiname: this.dateiname, kommentar: this.kommentar})
                            this.$router.go(-1)
                        }
                    });
                }
            }
        }

        doEdit(){
            this.editMode = false
            EventBus.$emit('edit', { dateiname: this.dateiname, kommentar: this.kommentar })
            this.$router.go(-1)
        }

        cancel() {
            this.$router.go(-1)
        }

        vorlageExists(dateiname) {
            const url = this.$root.$children[0].getBackendUrl() +
                `/api/backend-service/berechnungsvorlages/search/findByDateiname?dateiname=${dateiname}`;
            return fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            }).then(res => {
                if (res.status == 404) {
                    console.error(`Error: Endpoint not found`);
                    return;
                }
                if (res.status != 200) {
                    console.error(`error while calculating result with status:`+ res.status);
                    return;
                }
                return res.json();
            }).then(json => {
                let result = json._embedded["berechnungsvorlages"]
                if(result.length){
                    this.updateLink = result[0]._links.self.href
                    //save auditing for PUT update as well, otherwise becoming null
                    if(result[0].anlagedatum != null){
                        this.anlagedatum = result[0].anlagedatum
                    }
                    if(result[0].anlagenutzer != null){
                        this.anlagenutzer = result[0].anlagenutzer
                    }
                    console.log("found ", this.updateLink)
                }
                return result.length
            });
        }

        mounted() {
            if(!window.location.href.includes("auth")){
                console.log("redirect")
                const url = this.$root.$children[0].getBackendUrl() + `/auth/index.html#/save`;
                window.location.replace(url)
            }
        }

    }
</script>
